"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDaysNegative = function SvgBDaysNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M128.974 109.003H46.638a2.262 2.262 0 010-4.524h82.336a2.262 2.262 0 010 4.524zM34.296 109.003H3.716a2.262 2.262 0 010-4.524h30.58a2.262 2.262 0 010 4.524zM87.81 97.098a2.262 2.262 0 01-2.262-2.262V48.621a2.262 2.262 0 014.524 0v46.215a2.262 2.262 0 01-2.262 2.262zM45.092 72.219a2.262 2.262 0 01-2.261-2.262V39.4a2.262 2.262 0 014.523 0v30.557a2.262 2.262 0 01-2.262 2.262z"
  }), (0, _core.jsx)("path", {
    d: "M130.565 40.132H12.952a2.262 2.262 0 010-4.524h115.351v-15.47a4.968 4.968 0 00-4.96-4.961h-22.98a2.262 2.262 0 110-4.524h22.98a9.492 9.492 0 019.484 9.484V37.87a2.262 2.262 0 01-2.262 2.262zM130.565 118.457a2.262 2.262 0 01-2.262-2.262V48.553a2.262 2.262 0 014.524 0v67.642a2.262 2.262 0 01-2.262 2.262zM123.342 143.442h-78.28a2.262 2.262 0 110-4.523h78.28a4.968 4.968 0 004.961-4.961v-7.087a2.262 2.262 0 014.524 0v7.087a9.5 9.5 0 01-9.485 9.484z"
  }), (0, _core.jsx)("path", {
    d: "M34.364 143.442H9.484A9.5 9.5 0 010 133.958V20.115a9.492 9.492 0 019.484-9.462H20.04a2.262 2.262 0 110 4.524H9.484a4.968 4.968 0 00-4.96 4.96V133.98a4.968 4.968 0 004.96 4.961h24.88a2.262 2.262 0 110 4.524v-.023zM87.787 15.177H32.826a2.262 2.262 0 110-4.524h54.961a2.262 2.262 0 110 4.524z"
  }), (0, _core.jsx)("path", {
    d: "M30.82 25.882a2.262 2.262 0 01-2.261-2.261V2.26a2.262 2.262 0 114.523 0v21.36a2.262 2.262 0 01-2.261 2.261zM98.5 25.882a2.262 2.262 0 01-2.261-2.261V2.26a2.262 2.262 0 014.523 0v21.36a2.262 2.262 0 01-2.261 2.261zM87.81 132.759a2.262 2.262 0 01-2.262-2.262v-22.829a2.262 2.262 0 014.524 0v22.83a2.262 2.262 0 01-2.262 2.261zM45.092 141.354a2.262 2.262 0 01-2.261-2.262V84.214a2.262 2.262 0 014.523 0v54.878a2.262 2.262 0 01-2.262 2.262zM119.822 74.57H12.937a2.262 2.262 0 010-4.523h106.885a2.262 2.262 0 010 4.524z"
  }), (0, _core.jsx)("path", {
    d: "M48.772 109.62a2.262 2.262 0 01-1.599-3.867L82.45 70.477a2.266 2.266 0 113.205 3.204l-35.277 35.276a2.262 2.262 0 01-1.605.664z"
  }), (0, _core.jsx)("path", {
    d: "M84.048 109.621c-.6 0-1.175-.24-1.599-.664L47.173 73.681a2.263 2.263 0 113.197-3.204l35.284 35.276a2.262 2.262 0 01-1.606 3.868z"
  })));
};

var _default = SvgBDaysNegative;
exports["default"] = _default;